import { t } from 'i18next';
import { useState } from 'react';
import { SubTabs } from '../SubTabs';
import { SimpleButton } from '../styles';
import { Profile } from '~/helpers/userProfile';
import { NewTable } from '~/components';
import { ColumnsTable, IluminationListItem, NobreakListItem } from '../ClientPanel';

export const UtilityPanel = ({
  state,
  deleteUtility,
  openCreateEditUtility,
  profile,
  setState,
}: {
  state: {
    nobreakList: NobreakListItem[];
    nobreaksColumns: ColumnsTable[];
    iluminationList: IluminationListItem[];
    illuminationColumns: ColumnsTable[];
  };
  profile: Profile;
  deleteUtility: () => void;
  openCreateEditUtility: () => void;
  setState: (newState: { selectedUtility: string }) => void;
}): JSX.Element => {
  const [activeTab, setActiveTab] = useState(t('nobreak'));

  function changeActiveTab(tab: string) {
    setActiveTab(tab);
    setState({ selectedUtility: tab });
  }
  function utilityButtons() {
    const disabled = !state.nobreakList.some((item) => item.checked) && !state.iluminationList.some((item) => item.checked);
    return [(
      <div style={{ float: 'right', marginBottom: '20px' }}>
        {(profile.manageAllClients) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={openCreateEditUtility}>{t('novoUtilitario').toUpperCase()}</SimpleButton>}
        {(profile.permissions.isAdminSistema) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" disabled={disabled} onClick={deleteUtility}>{t('excluirUtilitarios')}</SimpleButton>}
      </div>
    )];
  }

  return (
    <>
      <SubTabs
        tabs={[t('nobreak'), t('iluminacao')]}
        activeTab={activeTab}
        onChange={changeActiveTab}
      />
      {activeTab === t('nobreak') && (
        <NewTable
          data={state.nobreakList}
          columns={state.nobreaksColumns}
          pageSize={20}
          extraBtns={utilityButtons()}
          hideEmptyTable
          keySearch="searchNobreak"
        />
      )}
      {activeTab === t('iluminacao') && (
        <NewTable
          data={state.iluminationList}
          columns={state.illuminationColumns}
          pageSize={20}
          extraBtns={utilityButtons()}
          hideEmptyTable
          keySearch="searchIllumination"
        />
      )}
    </>
  );
};
